import { CellEnd as BaseCellEnd, CenteredCell as BaseCenteredCell } from "@common/components/GridTable/GridTable";
import { vars } from "@common/styles";
import styled, { css } from "styled-components";

export const CenteredCell = styled(BaseCenteredCell)<{ $isBordered: boolean; $position: "left" | "middle" | "right" }>`
  position: relative;

  ${(props) =>
    props.$isBordered &&
    css`
      &::before {
        content: "";
        position: absolute;
        inset: 0;
        border-top: 1px solid ${vars.colors.redDarken};
        border-bottom: 1px solid ${vars.colors.redDarken};
        pointer-events: none;

        ${
          props.$position === "left"
            ? css`
                border-left: 1px solid ${vars.colors.redDarken};
                border-radius: 1rem 0 0 1rem;
                left: -1rem;
              `
            : props.$position === "right"
            ? css`
                border-right: 1px solid ${vars.colors.redDarken};
                border-radius: 0 1rem 1rem 0;
                right: -1rem;
              `
            : "" // For "middle", do nothing extra
        }
      }
    `}
`;

export const CellEnd = styled(BaseCellEnd)<{ $isBordered: boolean }>`
  position: relative;

  ${(props) =>
    props.$isBordered &&
    css`
      &::before {
        content: "";
        position: absolute;
        inset: 0;
        pointer-events: none;

        border-top: 1px solid ${vars.colors.redDarken};
        border-bottom: 1px solid ${vars.colors.redDarken};
        border-right: 1px solid ${vars.colors.redDarken};

        border-radius: 0 1rem 1rem 0;
        right: -1rem;
      }
    `}
`;
